import BilletRequests from "app/api/billet";
import ContractRequests from "app/api/contract";
import { handleGenericApiError } from "app/api/error";

import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_INSTALLMENT_STATUS_GENERAL_INFORMATION =
  "installmentStatus:ACTION_SAVE_INSTALLMENT_STATUS_GENERAL_INFORMATION";
export const ACTION_SAVE_INSTALLMENT_STATUS_FILES =
  "installmentStatus:ACTION_SAVE_INSTALLMENT_STATUS_FILES";
export const ACTION_SAVE_INSTALLMENT_STATUS_FILE_CONTROLS =
  "installmentStatus:ACTION_SAVE_INSTALLMENT_STATUS_FILE_CONTROLS";

export const fetchInstallmentStatusGeneralInformation =
  callback => async dispatch => {
    try {
      const data = await BilletRequests.fetchBilletGeneralInformation();
      if (callback && typeof callback === "function") {
        callback();
      }
      dispatch({
        type: ACTION_SAVE_INSTALLMENT_STATUS_GENERAL_INFORMATION,
        payload: data,
      });
    } catch (err) {
      handleGenericApiError(err);
    }
  };

export const fetchInstallmentStatusFiles = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data =
      await ContractRequests.fetchInstallmentSettlementFiles(
        params
      );
    dispatch({
      type: ACTION_SAVE_INSTALLMENT_STATUS_FILES,
      payload: data,
    });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchInstallmentStatusFileControls = id => async dispatch => {
  dispatch(addLoading());
  try {
    const data =
      await ContractRequests.fetchInstallmentSettlementFileControls(id);
    dispatch({
      type: ACTION_SAVE_INSTALLMENT_STATUS_FILE_CONTROLS,
      payload: data,
    });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const importInstallmentStatusCsv =
  (data, callback) => async dispatch => {
    dispatch(addLoading());
    try {
      const response =
        await ContractRequests.uploadInstallmentSettlement(data);
      if (callback && typeof callback === "function") {
        callback();
      }
      return response;
    } catch (err) {
      handleGenericApiError(err);
    } finally {
      dispatch(removeLoading());
    }
  };
